<span class="support-additional-info-label">{{ label() }}</span>
<span class="support-additional-info-value">
  <ng-content />
</span>
